<template>
  <div class="tabs-bar">
    <el-scrollbar class="tabs-bar__scroll">
      <div class="tabs-bar__list">
        <div
          v-for="tab in tabsStore.tabs"
          :key="tab.key"
          class="tabs-bar__item"
          :class="{ 'is-active': tab.key === tabsStore.active }"
          @click="router.push(tab.key)"
        >
          <span class="tabs-bar__dot" />
          <span class="tabs-bar__text">{{ tab.title }}</span>
          <el-icon v-if="!tab.affix" class="tabs-bar__close" @click.stop="close(tab.key)">
            <Close />
          </el-icon>
        </div>
      </div>
    </el-scrollbar>

    <el-dropdown class="tabs-bar__more" trigger="click" @command="onCommand">
      <el-icon><MoreFilled /></el-icon>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item command="current">关闭当前</el-dropdown-item>
          <el-dropdown-item command="others">关闭其他</el-dropdown-item>
          <el-dropdown-item command="all">关闭全部</el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useTabsStore } from '@/store/tabs'

/**
 * 页签栏 —— 旧工程是 MPA，每次点击菜单整页跳转，无法并行处理多个功能。
 * 新工程用页签保留多任务上下文，是迁移带来的实际体验提升之一。
 */

const router = useRouter()
const tabsStore = useTabsStore()

function close(key: string) {
  tabsStore.close(key)
  if (tabsStore.active) router.push(tabsStore.active)
}

function onCommand(cmd: string) {
  if (cmd === 'current') return close(tabsStore.active)
  if (cmd === 'others') return tabsStore.closeOthers(tabsStore.active)
  if (cmd === 'all') {
    tabsStore.closeAll()
    router.push(tabsStore.active || '/index')
  }
}
</script>

<style scoped lang="scss">
.tabs-bar {
  height: 40px;
  background: #fff;
  border-bottom: 1px solid $c-border-light;
  display: flex;
  align-items: center;
  padding: 0 8px;
  flex-shrink: 0;

  &__scroll {
    flex: 1;
  }

  &__list {
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    padding: 4px 0;
  }

  &__item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 26px;
    padding: 0 10px;
    font-size: 12px;
    color: $c-text-regular;
    background: #f4f6f9;
    border: 1px solid $c-border-light;
    border-radius: 3px;
    cursor: pointer;
    transition: all 0.15s;

    &:hover {
      color: $c-primary;
      border-color: $c-primary-light;
    }

    &.is-active {
      background: $c-primary;
      border-color: $c-primary;
      color: #fff;

      .tabs-bar__dot {
        background: #fff;
      }
    }
  }

  &__dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #c0c4cc;
  }

  &__close {
    font-size: 12px;

    &:hover {
      opacity: 0.7;
    }
  }

  &__more {
    cursor: pointer;
    padding: 0 6px;
    color: $c-text-secondary;
  }
}
</style>
